import React, { useEffect, useRef, useState } from "react";
import "./home.scss";
import { cities } from "../data";
import { BsFillArrowUpCircleFill, BsWhatsapp } from "react-icons/bs";
import Footer from "../Footer/Footer";
import { DiAndroid } from "react-icons/di";
import { useNavigate } from "react-router-dom";
import androidApp from "../kanafani-trave-app.apk";
import AOS from "aos";
import "aos/dist/aos.css";
function Home() {
  // ======================== IS PWA ====================
  const isPWA = window.matchMedia("(display-mode:standalone)").matches;
  let navigate = useNavigate();
  let [citiesState, setCitiesState] = useState(cities);
  let searchValue = useRef();
  const [isFilterDone, setIsFilterDone] = useState(false);
  const [notFound, setNotFound] = useState("");
  let handleSubmit = (e) => {
    e.preventDefault();
    let filterValue = citiesState.filter(
      (item) =>
        item.en.toLowerCase().includes(searchValue.current.value) ||
        item.text.includes(searchValue.current.value)
    );
    if (
      citiesState.some(
        (item) =>
          item.en.toLowerCase().includes(searchValue.current.value) ||
          item.text.includes(searchValue.current.value)
      )
    ) {
      setIsFilterDone(true);
      setCitiesState(filterValue);
      setNotFound("");
      // e.target.reset()
    } else {
      setNotFound("غير موجود, لكن الرجاء التحقق عبر الاتصال بنا");
      e.target.reset();
    }
  };

  let handleBack = () => {
    setCitiesState(cities);
    setIsFilterDone(false);
    setNotFound("");
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  let handleUp = () => {
    window.scroll({
      behavior: "smooth",
      top: 0,
    });
  };
  return (
    <div className="home">
      <div className="whatsappBtn">
        <a
          target="_blank"
          href="https://chat.whatsapp.com/6Fi3unOroQaFQzjbcLMAVy"
        >
          <BsWhatsapp />
        </a>
      </div>

      <div className="upArrow">
        <a onClick={handleUp}>
          <BsFillArrowUpCircleFill />
        </a>
      </div>

      <div className="baner">
        <img src={require("../images/baner.jpg")} alt="" />
      </div>

      <h1 className="title" data-aos="flip-left">
        خدماتنا
      </h1>
      <div className="infos" data-aos="flip-left">
        <a className="info-baner">
          <img src={require("../images/infos.jpg")} alt="" />
        </a>
        <ul>
          <li>تذاكر الطيران</li>
          <li>فيز سياحية</li>
          <li>حجوزات فندقية</li>
          <li>تأمين صحي</li>
          <li>نقل برا إلى لبنان</li>
          <li>قبولات جامعية</li>
          <li onClick={() => navigate("/contact")}>للاستفسار</li>
        </ul>
      </div>

      <h1 className="title" data-aos="flip-left">
        الرحلات و الفيز
      </h1>
      {isFilterDone ? (
        <h5 className="back-btn" data-aos="flip-left" onClick={handleBack}>
          رجوع
        </h5>
      ) : (
        <form onSubmit={handleSubmit} data-aos="flip-left">
          <input ref={searchValue} type="text" placeholder="ابحث عن البلد" />
          <button>بحث</button>
        </form>
      )}
      <h4 className="notFound" data-aos="flip-left">
        {notFound}
      </h4>

      <div className="cities">
        {citiesState?.map((item, i) => (
          <div key={i} className="city" data-aos="flip-left">
            <div className="cityText">
              <h1>{item.en}</h1>
              <h3>{item.text}</h3>
            </div>

            <a>
              <img src={item.img} alt="" />
            </a>
          </div>
        ))}
      </div>
      <h1 className="title title-bottom" data-aos="flip-left">
        يوجد المزيد الرجاء التواصل معنا
      </h1>
      {!isPWA && (
        <div className="getApp" data-aos="flip-left">
          <a className="android-logo">
            <img src={require("../images/android-logo.jpg")} alt="" />
          </a>
          <div className="android-logo-right">
            <h5>حمل الان الموقع على الاندرويد و تصفح بدون انترنت</h5>
            <a className="androidBtn" href={androidApp} download={androidApp}>
              <DiAndroid /> Download
            </a>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default Home;
